import React, { useContext } from 'react';

import Header from './components/Header';
import AboutMe from './components/AboutMe';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Testimonials from './components/Testimonials';
import ContactMe from './components/ContactMe';
import Footer from './components/Footer';
import Email from './components/Email';
import './styles.css';

// import { DarkModeContext } from './components/context/DarkModeContext';

export default function App() {
	// const { isDarkModeOn } = useContext(DarkModeContext);
	return (
		<div>
			<Header />
			<AboutMe />
			<Skills />
			{/* <Projects /> */}
			<Testimonials />
			<Email />
		</div>
	);
}
